import React from 'react';
import AutomationPropertiesTable from './AutomationPropertiesTable';

const AutomationProperties: React.FC = () => {
  return <AutomationPropertiesTable />;
};

export default AutomationProperties;